import { render } from "./LayoutFrame.vue?vue&type=template&id=5a910095"
import script from "./LayoutFrame.vue?vue&type=script&lang=js"
export * from "./LayoutFrame.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__